import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';

import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'lineup-list',
	templateUrl: './lineup-list.component.html',
	styleUrls: ['./lineup-list.component.scss'],
	providers: [BbTableService]
})

export class LineupListComponent extends AbstractListComponent implements OnInit, OnDestroy {

	putRightSub: Subscription;
	putRight: boolean;
	filterConfig: BbFilterConfiguration;

	constructor(protected bbTableService: BbTableService) {

		super(bbTableService);

		this.listConfiguration = {
			name: 'lineup',
			basePath: '/library/lineup',
			activePath: '/library/lineups',
			entityTranslation: this.translate.instant('LINEUP').toLowerCase(),
			entitiesTranslation: this.translate.instant('LINEUPS').toLowerCase()
		};
		// the presets are not being used yet in the html template
		this.filterConfig = {
			search: true,
			filters: [],
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('PUBLISHED'),
				value: 'published',
				filterSet: [{
					filters: [{
						type: 'lineup',
						field: 'status',
						operator: 'is',
						value: 'published'
					}]
				}],
			},
			{
				label: this.translate.instant('DRAFT'),
				value: 'draft',
				filterSet: [{
					filters: [{
						type: 'lineup',
						field: 'status',
						operator: 'is',
						value: 'draft'
					}]
				}],
			}]
		};
	}

	ngOnInit() {

		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();

		this.putRightSub = this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
	}

	ngOnDestroy() {
		if (this.putRightSub) {
			this.putRightSub.unsubscribe();
		}

		// We have to call this, otherwise this list will not be destroyed
		super.ngOnDestroy();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['library/lineup', row.data.id, 'general']);
		}
	}

}
